import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-logout\">\n  <path fill=\"currentColor\" d=\"M9.195 2.689h1.622v6.5H9.195v-6.5zM7.561 4.786v1.805a4.885 4.885 0 00-2.439 4.225 4.878 4.878 0 107.34-4.212l-.023-.012V4.786c2.402.991 4.061 3.314 4.061 6.025a6.5 6.5 0 11-8.982-6.009l.043-.016z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol